<template>
  <div class="pt-1 position-relative">
    <!-- Loader -->
    <div
      v-if="foldersLoadingParent"
      class="position-absolute d-flex justify-content-center py-20 w-100"
    >
      <wtr-loader class="d-block" variant="primary" addText></wtr-loader>
    </div>

    <!-- JSTree -->
    <div :class="{ 'fetch-class': foldersLoadingParent }">
      <v-jstree
        v-if="folders && folders.length"
        :data="folders"
        :show-checkbox="false"
        :allow-batch="true"
        @item-click="selectNode"
      >
        <!-- Custom node template -->
        <!-- <template #default="{ model }">
          <img
            class="folder-icon"
            :src="getEducationalFolderIcon(model)"
            alt="Folder icon"
          />
          <span class="folder-name">{{ model.text }}</span>
        </template> -->
         <template slot-scope="_">
          <div :title="_.model.name">
            <div v-on:click.prevent="selectNode(_.model)" :class="getActiveClass(_.model)">
              <span><img v-if="!_.model.loading" class="folder-icon-img-size" :src="require('@/assets/icons-new/'+getFolderIcon(_.model)+'.svg')" alt="Icon" /></span>
              <span>&nbsp;{{_.model.name}}</span>
            </div>
          </div>
        </template>
      </v-jstree>

      <!-- Empty state -->
      <div v-else class="text-center py-3">
        No folders available
      </div>
    </div>
  </div>
</template>

<script>
import * as folderTypes from "../../../constants/constants-folder";
import VJstree from 'vue-jstree';


export default {
  name: "educational-folders",
  data() {
    return {
      ...folderTypes,
      foldersLoadingParent: false,
    };
  },
    components: {
    // 'create-folder': createFolderComponent,
    // 'folder-actions': FoldersActionsComponent,
    VJstree,
  },
  props: {
    foldersLoading: Boolean,
    rootFolder: Object,
    selectedFolder: Object,
    copiedFolder: Object,
    activeFolder: Object,
    folders: {
      type: Array,
      default: () => [],
    },
    disableActions: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
  folders: {
    immediate: true,
    handler(newVal) {
      if (newVal && newVal.length && !this.activeFolder) {
        // auto-select the first folder
        this.selectNode(newVal[0]);
      }
    }
  }
},
  methods: {
    // ✅ Normalize API response to v-jstree format
    normalizeFolders(folders, suffix = "") {
      return folders.map((f, idx) => ({
        ...f,
        id: `${f.id}-${f.folderType || "EDU"}-${idx}${suffix}`, // ensure unique IDs
        text: f.name,
        children: f.children && f.children.length
          ? this.normalizeFolders(f.children, `-${idx}`)
          : [],
        opened: false,
        root: true,
        dropDisabled: true,
        dragDisabled: true,
      }));
    },

    getEducationalFolderIcon(folder) {
      try {
        const iconName = this.getFolderIcon(folder);
        return require(`@/assets/icons-new/${iconName}.svg`);
      } catch (e) {
        console.error("Error loading icon:", e);
        return require("@/assets/icons-new/Icons_Folder.svg");
      }
    },
    getFolderIcon({ folderType }) {
      switch (folderType) {
        case "EDUCATIONALPUBLIC":
          return "Icons_PublicAccessBox";
        case "EDUCATIONAL":
          return "Icons_Folder";
        default:
          return "Icons_Folder";
      }
    },

    // ✅ Emit click event
    selectNode(model) {
      this.$emit("selected", model.model);
    },
    
    getActiveClass(node) {
  if (!this.activeFolder || !node) return '';
  const forRoot = node && node.name === this.activeFolder.name;
  return forRoot ? 'fw-700' : '';
}
  },
};
</script>

<style scoped lang="scss">
.folder-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.folder-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
